<template>
  <div class="import-tool">
    <Modal v-model="visible" title="批量导入客户" :mask-closable="false" width="530" :footer-hide="true" class="my-modal top import-tool-modal2">
      <div class="box">
        <p class="text1">操作步骤：</p>
        <p class="text2">1、点击下载模板按钮。</p>
        <p class="text2">2、根据模板中的提示，将批量导入客户数据整理至模板中。</p>
        <p class="text2">3、将excel命名，如“20220901批量导入客户”，点击上传excel按钮，选择命名好的excel，点击确认上传。</p>
      </div>

      <div class="ivu-modal-footer">
        <Button type="primary" @click="$refs.importTemplate.open()">导入模板设置</Button>
        <Button type="primary" @click="download"><i class="iconfont icondaoru1"></i>下载模板</Button>
        <Upload ref="upload" 
          :show-upload-list="false" 
          class="upload-btn"
          :format="fileFormat"
          :max-size="2048"
          :data="data.uploadParams"
          :on-format-error="handleFormatError"
          :on-success="handleUploadSuccess"
          action="/buz/customerBase/importCustomer"
        >
          <Button type="primary"><i class="iconfont icondaochu"></i>上传excel</Button>
        </Upload>        
      </div>
    </Modal>

    <import-template-set ref="importTemplate"></import-template-set>
  </div>
</template>
<script>
import importTemplateSet from './importTemplateSet';
export default {
  props:['getInsureList'],
  components:{
    importTemplateSet
  },
  data() {
    return {
      fileFormat:['xls','xlsx'],
      visible:false,
      data:{}
    };
  },
  methods: {
    open(){
      this.visible = true;
    },
    download(){
      this.$http({
        url: "/buz/customerBase/exportTemplate",
        type: "POST",
        forced: true,
        responseType: "blob",
        All: true,
        data:[]
      }).then(res=>{
        this.$units.daochu(res);
      })
    },

    // 文件文件格式验证失败时的钩子，返回字段为 file, fileList
    handleFormatError(file){
      if(!this.fileFormat||this.fileFormat.length==0){
        return true;
      }
      const format = file.name.split("\.")[1];
      if(!this.fileFormat.includes(format)){
        this.$notice.msg("请上传"+this.fileFormat.join(",")+"格式的文件")
        return false;
      }
    },

    // 文件上传成功时的钩子，返回字段为 response, file, fileList
    handleUploadSuccess(res) {
      if(!res.httpCode){
        this.$Message.warning(res.msg);
        return
      }
      this.$http({
        url: "/buz/customerBase/exportTemplate",
        type: "POST",
        forced: true,
        responseType: "blob",
        All: true,
        data:res.data.failList,
        apiPermissionCode:'orderInuser_6_2'
      }).then((data) => {
        if(!res.data.failList.length){
          this.$Message.success("上传成功");
          this.getInsureList();
        }else{
          this.$Message.warning(res.data.failList[0].errorMsg);
          this.$units.daochu(data);
        }
      })
    }
  },
};
</script>
<style lang="scss" scoped>
.import-tool-modal2 /deep/ {
  .ivu-modal-header-inner{
    font-size: 14px;
    font-weight: bold;
    color: #3C464F;
  }
  .ivu-modal-close{
    top: 4px ;
    .ivu-icon-ios-close {
      font-size: 30px;
      color: #A8ADB7;
    }
  }
  .ivu-modal-header{
    padding: 0 20px;
    height: 40px;
    line-height: 40px;
  }
  .box {
    padding-top: 15px;
    padding-bottom: 10px;
    font-size: 12px;
    .text1 {
      color: #515C6F;
      margin-bottom: 15px;
    }
    .text2 {
      margin-bottom: 10px;
    }
  }
  .ivu-modal-footer {
    border-top: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-bottom: 30px;
    .iconfont {
      font-size: 14px;
      margin-right: 4px;
    }
    .upload-btn {
      margin-left: 10px;
    }
    button + button {
      margin-left: 10px;
    }
  }
}
</style>
